const { Component, Utils, DOMUtils } = window.Liftoff;

Component.register(
  "app-icon",
  class Image extends Component {
    constructor(config) {
      super(config);
      
      const envAppData = Liftoff.env.app_store_data || {};
      this.image = this.config.fallbackImage || envAppData.icon;
    }

    load() {
      if (this.image == null) {
        return Promise.resolve();
      }

      return Utils.loadImage(this.image);
    }

    layout(parentNode) {
      super.layout(parentNode);

      DOMUtils.empty(this.parentNode);

      if (this.image == null) return;

      const el = DOMUtils.createElement({
        tagName: "img",
        classList: ["app-icon"],
        attributes: { src: this.image },
      });

      this.parentNode.appendChild(el);
    }

    resize() {}

    start() {}

    stop() {}

    restart() {}
  }
);



// WEBPACK FOOTER //
// ./components/app-icon/app-icon.js